$(document).ready(function() {
  $(document).on("click", ".js-lang", function(e) {
    if (!((e.target).closest(".js-lang-list"))) {
      $(this).toggleClass("active");
    }
  });
  $("body").on("click", function(e) {
    if (!((e.target).closest(".js-lang"))) {
      $(".js-lang").removeClass("active");
    }
  });
});


// WEBPACK FOOTER //
// ./src/js/general/lang.js